/**
 * liveTracking — les événements Amplitude des gestes du live, sous les noms de l'ancien, pour que
 * les séries continuent à l'allumage (le design system n'émet rien : c'est l'écran qui mesure).
 *
 *  - « Veux-tu vraiment quitter ? » : `dialog.button.clicked` (`dialog_title` `Veux-tu-vraimen`,
 *    `button` `Quitter-le-LIVE`), et
 *    « Annuler » sous la croix (`button` `times`) : l'ancienne boîte (`exitButton`) n'avait pas
 *    de bouton « Annuler », sa croix en tenait lieu. Le voile et le retour d'Android ne mesurent
 *    rien : une boîte ne se mesure que sur ses boutons ;
 *  - la note fermée sans la donner : la croix de la boîte de note (`button` `times`) ;
 *  - « Quitter le live » sur la fin : `button.clicked.live_exit` (`EndSessionScreenStudent`).
 *
 * « C'est parti ! » du starting block se mesure avec l'entrée du live (`liveEntryTracking`).
 */
import { DIALOG_CLOSE, dialogButtonEvent } from "../../../hooks/trackDialogButton"
import { track, type TrackedEvent } from "../../../hooks/trackEvent"

/** L'ancienne boîte de sortie (`onExitPress`) : son titre et ses boutons. */
const LEAVE_TITLE = "Veux-tu vraiment quitter ?"

export const LIVE_EVENTS = {
    leaveConfirmed: dialogButtonEvent(LEAVE_TITLE, "Quitter le LIVE"),
    leaveCancelled: dialogButtonEvent(LEAVE_TITLE, DIALOG_CLOSE),
    ratingClosed: dialogButtonEvent("", DIALOG_CLOSE),
    endExit: { name: "button.clicked.live_exit" },
} satisfies Record<string, TrackedEvent>

export function trackLive(event: TrackedEvent): void {
    track(event)
}
